<template>
  <div class="">
    <div class="item">
      <img
        class="item-title"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/23d875e3b9e45f36a028088949e2839f.png"
        alt=""
      />
      <img
        class="item-image image-margin"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bae51c546e2561c0b101c3b61c8a579a.png"
        alt=""
      />
      <img
        class="item-image image-margin"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/298ca3023e68aac4ad1c79aff5a764dc.png"
        alt=""
      />
      <div class="right-container image-margin">
        <img
          class="item-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1028b71ceb9699b8f6f055c06919f3ce.png"
          alt=""
        />
        <div class="btn" @click="bindClick">查看更多权益</div>
      </div>
      <img
        class="item-image image-margin"
        @click="bindToVip"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/eee982d5707dc0ccbcb8d00ddf73388e.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick() {
      this.$betterwe.vipHomePage()
    },
    bindToVip() {
      this.$betterwe.vipHomePage({ card_type_attr: 3, vip_type_id: 3 })
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  position: relative;
  margin-bottom: 60px;

  .item-title {
    position: absolute;
    left: 50%;
    top: -94px;
    width: 260px;
    height: 101px;
    object-fit: contain;
    transform: translate(-50%, 0%);
  }

  .item-image {
    width: 100%;
  }

  .image-margin {
    margin-bottom: 19px;
  }

  .right-container {
    position: relative;
    overflow: hidden;
    .btn {
      position: absolute;
      left: 50%;
      bottom: 21px;
      transform: translate(-50%, 0%);
      width: 315px;
      height: 50px;
      background: #f21768;
      border-radius: 30px;
      font-weight: bold;
      font-size: 20px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
    }
  }
}
</style>
